import enUS from 'src/i18n/en-us.json';
import nlNL from 'src/i18n/nl-nl.json';

import { createI18n } from 'vue-i18n';

const messages = {
  'nl-NL': nlNL,
  'en-US': enUS,
};

const numberFormats = {
  'nl-NL': {
    currency: {
      style: 'currency',
      currency: 'EUR',
    },
    currencyNoCents: {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
  },
};

// Create I18n instance
const i18n = createI18n({
  locale: 'nl-NL',
  fallbackLocale: 'nl-NL',
  globalInjection: true,
  numberFormats,
  messages,
});

export default i18n;
